import { eventTypeStandard } from './internal/core';
import { pushWithGlobalSale } from './internal/pushWithGlobal';

import { type OrderEntity } from '~/apiClient';

export type UseTrackingVasReturn = {
    trackVasServicesAddButton: VoidFunction;
    trackVasPaymentAddButton: VoidFunction;
    trackVasOrderReceived: (order: OrderEntity) => void;
};

export const useTrackingVas = (): UseTrackingVasReturn => ({
    trackVasServicesAddButton(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: 'add_order',
            page_type: 'services_order_page',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackVasPaymentAddButton(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: 'add_order',
            page_type: 'payment_order_page',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackVasOrderReceived(order): void {
        const locale = useNuxtApp().$i18n.locale;
        const orderTotal = order.orderItems.reduce((sum, item) => sum + item.price, 0);

        pushWithGlobalSale(
            sales => ({
                event: 'order_received',
                page_type: 'order_received_tp',
                http_status_code: 200,
                lang: locale.value,
                sales,
                ...eventTypeStandard,
            }),
            { value: orderTotal, addServices: order }
        );
    },
});
